import React from "react";
import Container from "./ui/Container";
import Button from "./ui/Button";

const Hero = () => {
  const handleConsultationClick = (e: React.MouseEvent) => {
    e.preventDefault();
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleExploreServicesClick = (e: React.MouseEvent) => {
    e.preventDefault();
    const servicesSection = document.getElementById('services');
    if (servicesSection) {
      servicesSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section 
      className="pt-32 pb-20 md:pt-40 md:pb-32 relative overflow-hidden"
      style={{
        background: `linear-gradient(to bottom right, rgba(249, 250, 251, 0.9), rgba(30, 58, 138, 0.05)), 
                    radial-gradient(circle at 70% 30%, rgba(34, 211, 238, 0.1), transparent 70%)`,
      }}
    >
      {/* Decorative Elements - Adjusted for mobile */}
      <div className="absolute top-40 left-10 w-32 md:w-64 h-32 md:h-64 bg-tech-cyan opacity-5 rounded-full blur-2xl md:blur-3xl animate-float"></div>
      <div className="absolute top-60 right-10 w-40 md:w-80 h-40 md:h-80 bg-tech-blue opacity-5 rounded-full blur-2xl md:blur-3xl animate-pulse-soft"></div>

      <Container>
        <div className="grid md:grid-cols-2 gap-12 md:gap-6 items-center">
          <div className="order-2 md:order-1">
            <div className="space-y-6 max-w-xl">
              <div className="inline-block px-3 py-1 rounded-full bg-tech-blue/10 text-tech-blue font-medium text-sm mb-2 animate-fade-in opacity-0" style={{animationDelay: "0.1s", animationFillMode: "forwards"}}>
                Innovative Tech Solutions
              </div>
              
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-tech-blue leading-tight md:leading-tight lg:leading-tight opacity-0 animate-fade-in" style={{animationDelay: "0.3s", animationFillMode: "forwards"}}>
                Save Time & Money With Powerful Automation
              </h1>
              
              <p className="text-lg text-gray-700 max-w-lg opacity-0 animate-fade-in" style={{animationDelay: "0.5s", animationFillMode: "forwards"}}>
                At TechOvation.io, we streamline your business with AI-driven workflows, Salesforce integrations, and powerful automation—so you can focus on what matters.
              </p>
              
              <div className="flex flex-col sm:flex-row gap-4 pt-4 opacity-0 animate-fade-in" style={{animationDelay: "0.7s", animationFillMode: "forwards"}}>
                <Button 
                  size="lg" 
                  className="shadow-lg shadow-tech-orange/20"
                  onClick={handleConsultationClick}
                >
                  Schedule a Free Consultation
                </Button>
                <Button 
                  variant="outline" 
                  size="lg"
                  onClick={handleExploreServicesClick}
                >
                  Explore Services
                </Button>
              </div>
            </div>
          </div>
          
          <div className="order-1 md:order-2">
            <div className="glass-panel rounded-2xl p-5 relative z-10 opacity-0 animate-fade-in" style={{animationDelay: "0.9s", animationFillMode: "forwards"}}>
              <div className="relative aspect-[5/3] rounded-lg overflow-hidden shadow-2xl">
                <div className="absolute inset-0 bg-gradient-to-br from-tech-blue to-tech-cyan opacity-90"></div>
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="text-white text-center p-6">
                    <div className="grid grid-cols-3 gap-3 md:gap-5 mb-8">
                      {[1, 2, 3, 4, 5, 6].map((item) => (
                        <div key={item} className="bg-white/20 backdrop-blur-sm rounded-lg p-2 md:p-3 hover-scale">
                          <div className="w-6 h-6 md:w-10 md:h-10 rounded-md bg-white/30 mx-auto mb-2 animate-pulse-soft"></div>
                          <div className="h-1 md:h-2 bg-white/40 rounded-full w-full"></div>
                        </div>
                      ))}
                    </div>
                    <div className="h-2 md:h-3 bg-white/30 rounded-full w-3/4 mx-auto mb-2"></div>
                    <div className="h-2 md:h-3 bg-white/20 rounded-full w-1/2 mx-auto"></div>
                  </div>
                </div>
              </div>
              
              {/* Decorative elements for the panel - Adjusted for mobile */}
              <div className="absolute -bottom-2 -right-2 md:-bottom-4 md:-right-4 w-10 h-10 md:w-20 md:h-20 bg-tech-cyan rounded-full opacity-20 blur-xl"></div>
              <div className="absolute -top-2 -left-2 md:-top-4 md:-left-4 w-8 h-8 md:w-16 md:h-16 bg-tech-blue rounded-full opacity-20 blur-xl"></div>
            </div>
            
            {/* Floating elements - Adjusted for mobile */}
            <div className="absolute top-0 right-0 transform -translate-y-1/2 translate-x-1/4">
              <div className="w-10 h-10 md:w-20 md:h-20 bg-tech-orange/10 rounded-full animate-float"></div>
            </div>
            <div className="absolute bottom-0 left-0 transform translate-y-1/2 -translate-x-1/4">
              <div className="w-8 h-8 md:w-16 md:h-16 bg-tech-cyan/10 rounded-full animate-float" style={{animationDelay: "1s"}}></div>
            </div>
          </div>
        </div>
      </Container>
    </section>
  );
};

export default Hero;
